import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios";

function buildBaseUrl(): string {
  const raw = (process.env.REACT_APP_API_BASE_URL || "").trim();

  // CRA proxy mode → "/api" → localhost:5005
  if (!raw) return "/api";

  // remove trailing slash
  const base = raw.replace(/\/+$/, "");

  // if already ends with /api, do NOT append again
  if (base.toLowerCase().endsWith("/api")) {
    return base;
  }

  return `${base}/api`;
}

const api = axios.create({
  baseURL: buildBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * ✅ REQUEST INTERCEPTOR (FIXED FOR AXIOS v1 TYPES)
 */
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("token");
    if (!token) return config;

    // Axios v1-safe header handling
    const headers = AxiosHeaders.from(config.headers);
    headers.set("Authorization", `Bearer ${token}`);
    config.headers = headers;

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * ✅ RESPONSE ERROR NORMALIZATION
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    let errorMessage = "An error occurred";

    if (error.response) {
      errorMessage =
        error.response.data?.message ||
        error.response.data?.error ||
        `Error ${error.response.status}`;
    } else if (error.request) {
      errorMessage = "No response received from server";
    } else {
      errorMessage = error.message || "Unknown error";
    }

    error.displayMessage = errorMessage;
    return Promise.reject(error);
  }
);

export default api;
